import {
  DELETE_ACCOUNT_PREPARE_BEGIN,
  DELETE_ACCOUNT_PREPARE_END,
  DELETE_ACCOUNT_FINALISE_BEGIN,
  DELETE_ACCOUNT_FINALISE_END,
} from "../actions/deleteaccountactions";

const initialState = {
  loading: false,
};

export function deleteAccountReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case DELETE_ACCOUNT_PREPARE_BEGIN:
    case DELETE_ACCOUNT_FINALISE_BEGIN:
      nextState.loading = true;
      return nextState;
    case DELETE_ACCOUNT_FINALISE_END:
    case DELETE_ACCOUNT_PREPARE_END:
      nextState.loading = false;
      return nextState;
    default:
      return state;
  }
}
